// Note: These styles are all global and note scoped because
// some elements are created dynamically by the ReadSpeaker library

stzh-readspeaker {
  @include host;

  --background-color: var(--stzh-readspeaker-background-color, #{$colorWhite});
  --justify-content: var(--stzh-readspeaker-justify-content, space-between);
  --column-gap: var(--stzh-readspeaker-column-gap, auto);

  --audio-track-height: 3px;
  --audio-track-background-color: var(--stzh-readspeaker-audio-track-background-color, #{$colorBlack20op});
  --audio-track-progress-background-color: var(--stzh-readspeaker-audio-track-progress-background-color, #{$colorSecondary40});

  --dropdown-position: var(--stzh-readspeaker-dropdown-position, absolute);
  --dropdown-top: var(--stzh-readspeaker-dropdown-top, #{$formInputHeightSmall});
  --dropdown-bottom: var(--stzh-readspeaker-dropdown-bottom, auto);
  --dropdown-left: var(--stzh-readspeaker-dropdown-left, 0px);
  --dropdown-right: var(--stzh-readspeaker-dropdown-right, auto);

  --dropdown-settings-top: var(--stzh-readspeaker-dropdown-settings-top, #{$formInputHeightSmall});
  --dropdown-settings-bottom: var(--stzh-readspeaker-dropdown-settings-bottom, auto);
  --dropdown-settings-left: var(--stzh-readspeaker-dropdown-settings-left, 0px);
  --dropdown-settings-right: var(--stzh-readspeaker-dropdown-settings-right, auto);

  @include mq($from: medium) {
    --column-gap: var(--stzh-readspeaker-column-gap, #{space('medium')});
    --dropdown-top: var(--stzh-readspeaker-dropdown-top, #{$formInputHeightTiny});
    --dropdown-settings-top: var(--stzh-readspeaker-dropdown-settings-top, #{$formInputHeightTiny});
  }

  @media print {
    display: none;
  }
}

.stzh-readspeaker {
  position: relative;
  display: flex;
  align-items: center;
  column-gap: var(--column-gap);
  justify-content: var(--justify-content);

  &__actions {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  stzh-button#{&}__close {
    display: none;
  }

  &:has(.rsbtn.rsexpanded) &__close {
    display: inline-grid;

    @include mq($from: small) {
      display: none;
    }
  }

  .rsbtn {
    z-index: $zIndexPopover !important;
    background: var(--background-color);
    position: var(--dropdown-position);
    top: var(--dropdown-top);
    bottom: var(--dropdown-bottom);
    left: var(--dropdown-left);
    right: var(--dropdown-right);
  }

  .rs_splitbutton.rs_splitbutton-exp {
    display: inline-flex;
  }

  .rs_addtools,
  .rsbtn {
    margin-top: var(--audio-track-height);
    margin-bottom: 0px;
  }

  [class*=" rsicn-"],
  [class*=" rsicn-"]:before,
  [class^=rsicn-], [class^=rsicn-]:before {
    content: '';
    display: block;
    width: iconSize();
    height: iconSize();
    background-size: contain;
    background-position: center center;
  }

  // pause / play
  .rsicn-pause::before {
    background-image: svg-load('../src/components/stzh-readspeaker/assets/pause.svg', fill=#0F05A0);
  }

  .rsbtn_pause:hover .rsicn-pause::before {
    background-image: svg-load('../src/components/stzh-readspeaker/assets/pause.svg', fill=#070066);
  }

  .rsbtn.rsstopped .rsbtn_exp .rsbtn_exp_inner .rsbtn_pause .rsicn::before,
  .rsbtn.rsidle .rsbtn_exp .rsbtn_exp_inner .rsbtn_pause .rsicn::before,
  .rsbtn.rspaused .rsbtn_exp .rsbtn_exp_inner .rsbtn_pause .rsicn::before {
    content: '';
    background-image: svg-load('../src/components/stzh-readspeaker/assets/play.svg', fill=#0F05A0);
  }

  .rsbtn.rsstopped .rsbtn_exp .rsbtn_exp_inner .rsbtn_pause:hover .rsicn::before,
  .rsbtn.rsidle .rsbtn_exp .rsbtn_exp_inner .rsbtn_pause:hover .rsicn::before,
  .rsbtn.rspaused .rsbtn_exp .rsbtn_exp_inner .rsbtn_pause:hover .rsicn::before {
    content: '';
    background-image: svg-load('../src/components/stzh-readspeaker/assets/play.svg', fill=#070066);
  }

  // stop
  .rsicn-stop::before {
    background-image: svg-load('../src/components/stzh-readspeaker/assets/stop.svg', fill=#0F05A0);
  }

  .rsbtn_stop:hover .rsicn-stop::before {
    background-image: svg-load('../src/components/stzh-readspeaker/assets/stop.svg', fill=#070066);
  }

  // rewind
  .rsicn-backwards::before {
    background-image: svg-load('../src/components/stzh-readspeaker/assets/rewind.svg', fill=#0F05A0);
  }

  .rsbtn_rewind:hover .rsicn-backwards::before {
    background-image: svg-load('../src/components/stzh-readspeaker/assets/rewind.svg', fill=#070066);
  }

  // forwards
  .rsicn-forwards::before {
    background-image: svg-load('../src/components/stzh-readspeaker/assets/forward.svg', fill=#0F05A0);
  }

  .rsbtn_forward:hover .rsicn-forwards::before {
    background-image: svg-load('../src/components/stzh-readspeaker/assets/forward.svg', fill=#070066);
  }

  // volume
  .rsicn-volume::before {
    background-image: svg-load('../src/components/stzh-readspeaker/assets/volume-medium.svg', fill=#0F05A0);
  }

  .rsbtn_volume:hover .rsicn-volume::before {
    background-image: svg-load('../src/components/stzh-readspeaker/assets/volume-medium.svg', fill=#070066);
  }

  // speed
  .rsicn-speed::before {
    background-image: svg-load('../src/components/stzh-readspeaker/assets/dashboard.svg', fill=#0F05A0);
  }

  .rsbtn_speed:hover .rsicn-speed::before {
    background-image: svg-load('../src/components/stzh-readspeaker/assets/dashboard.svg', fill=#070066);
  }

  // close
  .rsbtn .rsbtn_exp .rsbtn_exp_inner .rsbtn_closer:focus span.rsicn::before,
  .rsbtn .rsbtn_exp .rsbtn_exp_inner .rsbtn_closer:hover span.rsicn::before {
    content: '';
  }

  .rsicn-cross::before {
    background-image: svg-load('../src/components/stzh-readspeaker/assets/close-big.svg', fill=#0F05A0);
  }

  .rsbtn_closer:hover .rsicn-cross::before {
    background-image: svg-load('../src/components/stzh-readspeaker/assets/close-big.svg', fill=#070066);
  }

  // tooltoggle
  .rs_addtools .rsbtn_tooltoggle .rsicn::before,
  .rsbtn .rsbtn_tooltoggle .rsicn::before {
    content: '';
  }

  .rsicn-arrow-down::before {
    background-image: svg-load('../src/components/stzh-readspeaker/assets/more-vertical.svg', fill=#0F05A0);
  }

  .rsbtn_tooltoggle:hover .rsicn-arrow-down::before {
    background-image: svg-load('../src/components/stzh-readspeaker/assets/more-vertical.svg', fill=#070066);
  }

  // loading indicator/track
  #rsmpl_container .rs-player-loadindicator,
  .rsbtn .rs-player-loadindicator {
    background-color: var(--audio-track-background-color);
    height: var(--audio-track-height);
    top: calc(var(--audio-track-height) / -1);
    left: 0;
    right: 0px;
  }

  #rsmpl_container .rs-player-loadindicator .rsbtn-loading,
  .rsbtn .rs-player-loadindicator .rsbtn-loading,
  #rsmpl_container .rs-player-loadindicator .rsbtn-progress,
  .rsbtn .rs-player-loadindicator .rsbtn-progress {
    background-color: var(--audio-track-progress-background-color);
  }

  // player buttons / toggle button
  .rsbtn .rsbtn_exp .rsbtn_exp_inner .rsbtn_player_item,
  .rsbtn .rsbtn_exp .rsbtn_exp_inner .rsbtn_player_item:active,
  .rs_splitbutton.rsexpanded:not(.rsdetached).rs_addtools .rsbtn_tooltoggle,
  .rs_splitbutton.rsexpanded:not(.rsdetached).rsbtn .rsbtn_tooltoggle {
    display: flex;
    justify-content: center;
    align-items: center;
    border-left: none;
    width: $formInputHeightSmall;
    height: $formInputHeightSmall;
    transition-property: background-color;
    transition-duration: $baseTransitionAnimationSpeed;
    background-color: transparent;
    outline: none;
    float: none;

    [class*=" rsicn-"],
    [class*=" rsicn-"]:before,
    [class^=rsicn-], [class^=rsicn-]:before {
      width: iconSize();
      height: iconSize();

      @include mq($from: medium) {
        width: iconSize('small');
        height: iconSize('small');
      }
    }

    @include mq($from: medium) {
      width: $formInputHeightTiny;
      height: $formInputHeightTiny;
    }

    &:focus {
      background-color: transparent;
      outline: var(--stzh-flyingfocus-color) solid 2px;
      outline-offset: 2px;
    }

    &:hover {
      background-color: $colorSecondary20;
    }

    &.rsbtn_closer {
      // position: absolute;
      // right: 0;
      // top: calc(#{$formInputHeightSmall} / -1 + -3px);

      // we show own &__close button on mobile that is placed next to trigger
      @include mq($to: small) {
        display: none;
      }
    }
  }

  .rs_splitbutton.rsexpanded:not(.rsdetached).rs_addtools .rsbtn_tooltoggle,
  .rs_splitbutton.rsexpanded:not(.rsdetached).rsbtn .rsbtn_tooltoggle {
    margin-right: space('xxxsmall');
  }

  .rs_splitbutton .rsbtn_exp .rsbtn_exp_inner button.rsbtn_pause.rsbtn_player_item {
    padding-left: 0px;
    padding-right: 0px;
  }

  .rsbtn .rsbtn_exp .rsbtn_exp_inner .rsbtn_stop:active span.rsicn {
    background: transparent;
  }

  // toggle button
  .rs_splitbutton.rsexpanded:not(.rsdetached).rs_addtools .rsbtn_tooltoggle,
  .rs_splitbutton.rsexpanded:not(.rsdetached).rsbtn .rsbtn_tooltoggle {
    display: flex !important;
    position: relative;
    top: 0;
    border-left: none;
    border-right: none;
  }

  // toggle button when zoom-tooltoggler class is added to wrapper (js hover)
  .rs_splitbutton.zoom-tooltoggler.rsexpanded:not(.rsdetached).rs_addtools .rsbtn_tooltoggle,
  .rs_splitbutton.zoom-tooltoggler.rsexpanded:not(.rsdetached).rsbtn .rsbtn_tooltoggle {
    left: 0;
  }

  .rsbtn .rsbtn_exp .rsbtn_exp_inner {
    position: static;
    background: transparent;
    display: inline-flex;
    border: none;
    border-radius: 0px;
    gap: space('xxxsmall');
  }

  .rsbtn .rsbtn_exp,
  .rsbtn.rsexpanded .rsbtn_exp .rsbtn_exp_inner {
    height: auto;
  }

  // slider
  .rsbtn .rsbtn_exp .rsbtn_exp_inner .rsbtn_dropdown {
    box-sizing: border-box;
    border: none;
    width: $formInputHeightSmall;
    height: 116px;
    top: $formInputHeightSmall;
    margin-top: space('xxsmall');
    background-color: $colorGrey10;
    padding: 0;
    padding-top: space('xsmall');
    padding-bottom: space('xsmall');

    @include mq($from: medium) {
      width: $formInputHeightTiny;
      top: $formInputHeightTiny;
    }
  }

  #rs-textsettings input.rs-slider[type=range],
  .rs-dialog-esque input.rs-slider[type=range],
  .rs-dialog-slider-dropdown input.rs-slider[type=range],
  .rsbtn input.rs-slider[type=range] {
    overflow: hidden;
    -webkit-appearance: none !important;
    appearance: none !important;
    background: transparent;
    margin: 0px;

    --thumb-height: 20px;
    --thumb-border-width: 2px;
    --thumb-border-color: #{$colorPrimary70};
    --thumb-background-color: #{$colorWhite};
    --track-height: 8px;
    --track-color: #{$colorBlack40op};
    --track-progress-color: #{$colorSecondary60};
    --clip-edges: 1px;

    // &,
    // &::-moz-range-track,
    // &::-moz-range-thumb,
    // &::-moz-range-progress {
    //   background: #fff0;
    // }

    &,
    &::-webkit-slider-runnable-track,
    &::-webkit-slider-thumb {
      position: relative;
      -webkit-appearance: none;
      transition: all $baseTransitionAnimationSpeed;
      height: var(--thumb-height);
    }

    &,
    &::-moz-range-track,
    &::-moz-range-thumb {
      position: relative;
      margin: 0px;
      appearance: none;
      transition: all $baseTransitionAnimationSpeed;
      height: var(--thumb-height);
    }

    &::-webkit-slider-runnable-track {
  	  background: linear-gradient(var(--track-color) 0 0) scroll no-repeat center / 100% calc(var(--track-height) + 1px);
    }

    &::-moz-range-track {
      width: 100%;
      background: var(--track-color);
    }

    &::-moz-range-progress {
      appearance: none;
      background: var(--track-progress-color);
      transition-delay: 30ms;
    }

    &::-moz-range-track,
    &::-moz-range-progress {
      height: calc(var(--track-height) + 1px);
      border-radius: var(--track-height);
    }

    &::-webkit-slider-thumb {
      --thumb-radius: calc((var(--thumb-height) * 0.5) - 1px);
      --clip-top: calc((var(--thumb-height) - var(--track-height)) * 0.5 - 0.5px);
      --clip-bottom: calc(var(--thumb-height) - var(--clip-top));
      --clip-further: calc(100% + 1px);
      --box-fill: calc(-100vmax - var(--thumb-width, var(--thumb-height))) 0 0 100vmax var(--track-progress-color);

      width: var(--thumb-width, var(--thumb-height));
      // background: linear-gradient(currentColor 0 0) scroll no-repeat left center / 50% calc(var(--track-height) + 1px);
      background-color: var(--thumb-background-color);
      border-style: solid;
      border-width: var(--thumb-border-width);
      border-color: var(--thumb-border-color);
      box-shadow: var(--box-fill);
      border-radius: var(--thumb-width, var(--thumb-height));

      filter: brightness(100%);
      clip-path: polygon(
        100% -1px,
        var(--clip-edges) -1px,
        0 var(--clip-top),
        -100vmax var(--clip-top),
        -100vmax var(--clip-bottom),
        0 var(--clip-bottom),
        var(--clip-edges) 100%,
        var(--clip-further) var(--clip-further)
      );
    }

    &::-moz-range-thumb {
      background-color: var(--thumb-background-color);
      border-style: solid;
      border-width: var(--thumb-border-width);
      border-color: var(--thumb-border-color);
      border: 0;
      width: var(--thumb-width, var(--thumb-height));
      border-radius: var(--thumb-width, var(--thumb-height));
      cursor: grab;
    }

    &:active {
      cursor: grabbing;
    }

    &:active::-webkit-slider-thumb {
      cursor: grabbing;
    }

    &:active::-moz-range-thumb {
      cursor: grabbing;
    }

    &:disabled {
      cursor: not-allowed;
    }

    &:disabled::-webkit-slider-thumb {
      cursor: not-allowed;
    }

    &:disabled::-moz-range-thumb {
      cursor: not-allowed;
    }
  }

  .rsbtn .rs-slider.vertical,
  .rsbtn .rs-slider.vertical.has-datalist {
    // transform: rotate(270deg) translateX(-4.75em) translateY(.75em);
    transform: rotate(270deg) translateX(-6px) translateY(-6px);
    transform-origin: bottom center;
    width: 100px;
    height: $formInputHeightSmall;

    @include mq($from: medium) {
      height: $formInputHeightTiny;
      transform: rotate(270deg) translateX(-18px) translateY(-18px);
    }
  }

  // slider tooltip
  #rs-textsettings .rs-slider-label,
  .rs-dialog-esque .rs-slider-label,
  .rs-dialog-slider-dropdown .rs-slider-label,
  .rsbtn .rs-slider-label {
    @include font;
    @include tooltip-fontsize;
    border-radius: 0px;
    border: none;
    box-shadow: none;
    color: $colorWhite;
    background-color: $colorCoolgrey60;
    height: 20px;
    line-height: 20px;
    padding: 0;
    padding-left: space('xxsmall');
    padding-right: space('xxsmall');
  }

  // copyright
  .rsbtn_powered {
    display: none;
  }

  // menu container
  .rs_addtools .rsbtn_toolpanel.vertical,
  .rsbtn .rsbtn_toolpanel.vertical {
    position: absolute;
    top: var(--dropdown-settings-top);
    bottom: var(--dropdown-settings-bottom);
    left: var(--dropdown-settings-left);
    right: var(--dropdown-settings-right);
    min-width: initial !important;
  }

  .rs_addtools .rsbtn_toolpanel.vertical .rsbtn_tools,
  .rsbtn .rsbtn_toolpanel.vertical .rsbtn_tools {
    position: static;
    border-radius: 0px;
    border: none;
    margin-top: space('xxsmall');
    background-color: $colorGrey10;
    padding-top: space('xsmall');
    padding-bottom: space('xsmall');
  }

  .rs_addtools .rsbtn_toolpanel.vertical
  .rsbtn_tools .rsbtn_tools_inner .rsbtn_toolcontainer ul.rsbtn_toollist li,
  .rsbtn .rsbtn_toolpanel.vertical .rsbtn_tools .rsbtn_tools_inner .rsbtn_toolcontainer ul.rsbtn_toollist li {
    all: unset;
  }

  // menu button
  .rs_addtools .rsbtn_toolpanel.vertical .rsbtn_tools .rsbtn_tools_inner .rsbtn_toolcontainer ul.rsbtn_toollist li button.rsbtn_tool,
  .rsbtn .rsbtn_toolpanel.vertical .rsbtn_tools .rsbtn_tools_inner .rsbtn_toolcontainer ul.rsbtn_toollist li button.rsbtn_tool {
    display: flex;
    align-items: center;
    padding: space('xsmall') space('large');
    white-space: nowrap;
    color: $colorPrimary70;
    transition-property: color, background-color;
    transition-duration: $baseTransitionAnimationSpeed;

    &:hover {
      color: $colorPrimary80;
      background-color: $colorSecondary20;
    }
  }

  .rs_addtools .rsbtn_toolpanel.vertical .rsbtn_tools .rsbtn_tools_inner .rsbtn_toolcontainer ul.rsbtn_toollist li button.rsbtn_tool span.rsbtn_btnlabel,
  .rsbtn .rsbtn_toolpanel.vertical .rsbtn_tools .rsbtn_tools_inner .rsbtn_toolcontainer ul.rsbtn_toollist li button.rsbtn_tool span.rsbtn_btnlabel {
    @include font('heavy');
    @include fontSize('milli');
    margin-left: space('xsmall');
    margin-right: auto;
    color: inherit;
  }

  .rsicn-settings::before {
    background-image: svg-load('../src/components/stzh-readspeaker/assets/gear.svg', fill=#0F05A0);
  }

  .rsbtn_tool:hover .rsicn-settings::before {
    background-image: svg-load('../src/components/stzh-readspeaker/assets/gear.svg', fill=#070066);
  }

  .rsicn-click-listen::before {
    background-image: svg-load('../src/components/stzh-readspeaker/assets/click.svg', fill=#0F05A0);
  }

  .rsbtn_tool:hover .rsicn-click-listen::before {
    background-image: svg-load('../src/components/stzh-readspeaker/assets/click.svg', fill=#070066);
  }

  .rsicn-enlarged-text::before {
    background-image: svg-load('../src/components/stzh-readspeaker/assets/enlarge-text.svg', fill=#0F05A0);
  }

  .rsbtn_tool:hover .rsicn-enlarged-text::before {
    background-image: svg-load('../src/components/stzh-readspeaker/assets/enlarge-text.svg', fill=#070066);
  }

  .rsicn-textmode::before {
    background-image: svg-load('../src/components/stzh-readspeaker/assets/text-mode.svg', fill=#0F05A0);
  }

  .rsbtn_tool:hover .rsicn-textmode::before {
    background-image: svg-load('../src/components/stzh-readspeaker/assets/text-mode.svg', fill=#070066);
  }

  .rsicn-pagemask::before {
    background-image: svg-load('../src/components/stzh-readspeaker/assets/scan.svg', fill=#0F05A0);
  }

  .rsbtn_tool:hover .rsicn-pagemask::before {
    background-image: svg-load('../src/components/stzh-readspeaker/assets/scan.svg', fill=#070066);
  }

  // switch
  .rs_addtools .rsbtn_toolpanel.vertical .rsbtn_tools .rsbtn_tools_inner .rsbtn_toolcontainer ul.rsbtn_toollist li button.rsbtn_tool .rs_minitoggler,
  .rsbtn .rsbtn_toolpanel.vertical .rsbtn_tools .rsbtn_tools_inner .rsbtn_toolcontainer ul.rsbtn_toollist li button.rsbtn_tool .rs_minitoggler {
    margin: 0;
    margin-left: space('large');
    background-color: $colorGrey70;
    border-radius: 12px;
    box-sizing: border-box;
    width: 48px;
    height: 24px;
    border: none;
    transition: background-color $baseTransitionAnimationSpeed;

    .on-icon,
    .off-icon {
      display: none;
    }

    &::after {
      width: 20px;
      height: 20px;
      top: 2px;
      left: 2px;
      transition: all $baseTransitionAnimationSpeed;
      background-color: $colorWhite;
    }
  }

  .rs_addtools .rsbtn_toolpanel.vertical .rsbtn_tools .rsbtn_tools_inner .rsbtn_toolcontainer ul.rsbtn_toollist li button.rsbtn_tool.active .rs_minitoggler,
  .rsbtn .rsbtn_toolpanel.vertical .rsbtn_tools .rsbtn_tools_inner .rsbtn_toolcontainer ul.rsbtn_toollist li button.rsbtn_tool.active .rs_minitoggler {
    background-color: $colorSecondary50;

    &::after {
      left: calc(50% + 2px);
      background-color: $colorWhite;
    }
  }
}

/* Button tooltips */

#readspeaker_tooltip.rs_tooltip {
  @include font;
  @include tooltip-fontsize;
  z-index: $zIndexPopup;
  border: none;
  border-radius: 0px;
  box-shadow: none;
  color: $colorWhite;
  background-color: $colorCoolgrey60;
  height: 20px;
  line-height: 20px;
  padding: 0;
  padding-left: space('xxsmall');
  padding-right: space('xxsmall');
}

/* Popup on text selection */

.rspopup.rspopup {
  z-index: $zIndexPopup;
  background: $colorGrey10;
  border: none;
  border-radius: 0px;
  box-shadow: none;

  .rspopup_btn {
    height: $formInputHeightSmall;
    box-sizing: border-box;
    display: flex;
    padding: space('xsmall') space('large');
    justify-content: center;
    align-items: center;
    gap: space('xsmall');
    border-top: none;
    color: $colorPrimary70;
    transition-property: color, background-color;
    transition-duration: $baseTransitionAnimationSpeed;

    &:hover {
      color: $colorPrimary80;
      background-color: $colorSecondary20;
    }

    &.rspopup_play::before {
      content: '';
      margin-right: 0;
      left: 0;
      position: relative;
      width: iconSize();
      height: iconSize();
      background-size: contain;
      background-position: center center;
      background-image: svg-load('../src/components/stzh-readspeaker/assets/volume-medium.svg', fill=#0F05A0);
    }

    &.rspopup_play:hover::before {
      background: svg-load('../src/components/stzh-readspeaker/assets/volume-medium.svg', fill=#070066);
    }

    &.rspopup_play::after {
      content: none;
    }
  }

  .rspopup_btn span.rspopup_label {
    @include font('heavy');
    @include fontSize('milli');
    top: 0;
  }
}

/* Sticky controls (currently disabled) */

// .rsbtn_scrollcontrols {}
